<np-pin-twillio-authy [buttonName]="btnName" [pinCodeError]="pinCodeError" (submitted)="login($event)"
  (onetouchApproved)="login()" (sendCode)="sendCode($event)" [ticketType]="ticketType" [userId]="registerInfor.userId"
  [email]="registerInfor.email" (exceedInvalidCode)="exceedInvalidCode()" [sendOnetouchSuccess]="sendOnetouchSuccess">
</np-pin-twillio-authy>